import { lazy, Suspense } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider } from 'react-router'
import { Toaster } from '@/components/ui/Toast'
import { account } from '@/lib/auth'
import { queryClient } from './queryClient'
import { router } from './router'

const LoginPage = lazy(() => import('@/features/auth/pages/LoginPage').then((m) => ({ default: m.LoginPage })))

export function App() {
  // 未登入只渲染登入頁（同舊版 index.jsx）
  if (!account.username) {
    return (
      <Suspense fallback={null}>
        <LoginPage />
      </Suspense>
    )
  }

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster />
      {/* 截圖比對工具（Playwright，navigator.webdriver = true）時不顯示，否則右下角按鈕會被算成跟舊版的差異 */}
      {!navigator.webdriver && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  )
}
